<template>
  <div class="login">
    <div>
      <div>
        <img src="../assets/images/logo_q@4x.png" style="width: 500px;margin: 60px;cursor: pointer;" @click="goHome">
      </div>
      <div class="mainBody">
        <img src="../assets/images/zt@2x.png" style="width: 774px;height: 525px;">
        <div v-if="!flag" style="width: 400px;height: 500px;background: #fff;box-shadow: 3px 2px 40px 0px rgba(127,157,197,0.21);
      border-radius: 20px;box-sizing: border-box;padding: 50px 30px;position: relative;">
          <div style="font-size: 30px;font-family: PingFang SC;font-weight: bold;color: #20242A;line-height: 11px;">
            Hello! 欢迎登录</div>
          <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" class="demo-dynamic">

            <el-form-item prop="username" label="用户名" :rules="[
                { required: true, message: '请输入您的用户名', trigger: 'blur' }
              ]">
              <div style="border-bottom: 1px solid #DAE6F8;">
                <el-input v-model="dynamicValidateForm.username" placeholder="请输入您的用户名"></el-input>
              </div>
            </el-form-item>

            <el-form-item prop="password" label="登录密码" :rules="[
                { required: true, message: '请输入您的登录密码', trigger: 'blur' }
              ]">
              <div style="border-bottom: 1px solid #DAE6F8;">
                <el-input show-password v-model="dynamicValidateForm.password" placeholder="请输入您的登录密码"></el-input>
              </div>
            </el-form-item>

          </el-form>

          <div style="position: absolute;bottom: 40px;text-align: center;">
            <div
              style="width: 330px;height: 60px;background: #0C67D8;border-radius: 30px;color: #fff;text-align: center;line-height: 60px;cursor: pointer;"
              @click="login(1, 'dynamicValidateForm')">
              登录</div>
            <div
              style="font-size: 14px;font-family: PingFang SC;font-weight: 400;color: #3A475C;line-height: 11px;margin-top: 25px;cursor: pointer;"
              @click="setRegister">免费注册</div>
            <!--            <a href="/oauth2/authorization/platform">平台登陆</a>-->
          </div>
        </div>

        <div v-else style="width: 400px;height: 670px;background: #fff;box-shadow: 3px 2px 40px 0px rgba(127,157,197,0.21);
        border-radius: 20px;box-sizing: border-box;padding: 50px 30px;position: relative;top: -170px;">
          <div style="font-size: 30px;font-family: PingFang SC;font-weight: bold;color: #20242A;line-height: 11px;">
            注册</div>
          <!-- <div>
            <div style="border-bottom: 1px solid #DAE6F8;">
              <div style="font-size: 14px;font-family: PingFang SC;color: #20242A;line-height: 11px;margin-top: 35px;">
                用户名</div>
              <el-input v-model="register.username" placeholder="请输入您的用户名"></el-input>
            </div>
            <div style="border-bottom: 1px solid #DAE6F8;">
              <div style="font-size: 14px;font-family: PingFang SC;color: #20242A;line-height: 11px;margin-top: 20px;">
                登录密码</div>
              <el-input show-password v-model="register.password" placeholder="请输入您的登录密码"></el-input>
            </div>
            <div style="border-bottom: 1px solid #DAE6F8;">
              <div style="font-size: 14px;font-family: PingFang SC;color: #20242A;line-height: 11px;margin-top: 20px;">
                确认密码</div>
              <el-input show-password v-model="register.qrPassword" placeholder="请输入您的登录密码"></el-input>
            </div>
            <div style="border-bottom: 1px solid #DAE6F8;">
              <div style="font-size: 14px;font-family: PingFang SC;color: #20242A;line-height: 11px;margin-top: 20px;">
                手机号</div>
              <el-input v-model="register.phone" placeholder="请输入您的手机号"></el-input>
            </div>

          </div> -->
          <el-form :model="register" ref="register" class="demo-dynamic">

            <el-form-item prop="username" label="用户名" :rules="[
                { required: true, message: '请输入您的用户名', trigger: 'blur' }
              ]">
              <div style="border-bottom: 1px solid #DAE6F8;">
                <el-input v-model="register.username" placeholder="请输入您的用户名"></el-input>
              </div>
            </el-form-item>

            <el-form-item prop="password" label="登录密码" :rules="[
                { required: true, message: '请输入您的登录密码', trigger: 'blur' }
              ]">
              <div style="border-bottom: 1px solid #DAE6F8;">
                <el-input show-password v-model="register.password" placeholder="请输入您的登录密码"></el-input>
              </div>
            </el-form-item>

            <el-form-item prop="qrPassword" label="确认密码" :rules="[
                { required: true, message: '请输入您的登录密码', trigger: 'blur' }
              ]">
              <div style="border-bottom: 1px solid #DAE6F8;">
                <el-input show-password v-model="register.qrPassword" placeholder="请输入您的登录密码"></el-input>
              </div>
            </el-form-item>

            <el-form-item prop="phone" label="手机号" :rules="[
                { required: true, message: '请输入您的手机号', trigger: 'blur' }
              ]">
              <div style="border-bottom: 1px solid #DAE6F8;">
                <el-input v-model="register.phone" placeholder="请输入您的手机号"></el-input>
              </div>
            </el-form-item>

          </el-form>
          <div style="position: absolute;bottom: 40px;text-align: center;">
            <div
              style="width: 330px;height: 60px;background: #0C67D8;border-radius: 30px;color: #fff;text-align: center;line-height: 60px;cursor: pointer;"
              @click="login(2, 'register')">
              注册</div>
            <div
              style="font-size: 14px;font-family: PingFang SC;font-weight: 400;color: #3A475C;line-height: 11px;margin-top: 25px;cursor: pointer;"
              @click="setRegister">已有帐号，去<span style="color: #0C67D8">登录</span></div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import {
    getRegister,
    getLogin
  } from '@/api/api'
  import JSEncrypt from 'jsencrypt/bin/jsencrypt'
  import {
    setCookie
  } from '@/utils/util.js'
  import * as axios from '../utils/request'

  const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANL378k3RiZHWx5AfJqdH9xRNBmD9wGD\n' +
    '2iRe41HdTNF8RUhNnHit5NpMNtGL0NPTSSpPjjI1kJfVorRvaQerUgkCAwEAAQ=='
  export default {
    data() {
      return {
        dynamicValidateForm: {
          username: '',
          password: ''
        },

        flag: false,
        loading: false,
        register: {
          password: '',
          phone: '',
          qrPassword: '',
          username: ''
        }
      }
    },
    methods: {
      goHome() {
        this.$router.push({
          path: '/home'
        })
      },
      setEncrypt: function(publicKey, data) {
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(publicKey)

        return encrypt.encrypt(data)
      },
      setRegister() {
        this.dynamicValidateForm = {
            username: '',
            password: ''
          },
          this.register = {
            password: '',
            phone: '',
            qrPassword: '',
            username: ''
          }
        this.flag = !this.flag
      },
      login(val, formName) {
        // if (this.loading) {
        //   return
        // }
        // this.loading = true
        if (val == 1) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const form = new FormData();
              form.append('username', this.dynamicValidateForm.username);
              form.append('password', this.dynamicValidateForm.password);
              axios.post('/login', form).then(res => {
                console.log(res)
                location.href = res.url
              }).catch(error => {
                if (error.response) {
                  return this.$message.error(error.response.data.message);
                }
              })
            } else {
              console.log('error submit!!')
              return false
            }
          })
        } else if (val == 2) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              getRegister(this.register).then(res => {
                this.register = {
                  password: '',
                  phone: '',
                  qrPassword: '',
                  username: ''
                }
                this.loading = false
                this.flag = false
                this.$message({
                  showClose: true,
                  message: '注册成功',
                  type: 'success'
                })
              })
            } else {
              console.log('error submit!!')
              return false
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  .login {
    width: 100%;
    height: 100vh;
    background: url('../assets/images/login@2x.png') top left no-repeat;
    background-size: cover;
    position: relative;
  }

  /deep/ .el-input__inner {
    /* margin-top: 10px; */
    border: none;
    padding: 0 10px;
    /* border-bottom: 1px solid #e6e6e6; */
  }

  /deep/ .el-form-item__content {
    margin-left: 0px !important;
  }

  .mainBody {
    display: flex;
    justify-content: space-between;
    width: 1370px;
    height: 527px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -40%);
  }

  .demo-dynamic {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue